import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Menu,
  MenuItem,
  useMediaQuery
} from '@mui/material';
import carouselData from './CarouselData.json';

const CarouselSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const isMobile = useMediaQuery('(max-width: 600px)');

  const { carousel } = carouselData;

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % carousel.length);
    }, 3000);

    return () => clearInterval(intervalId);
  }, [carousel]);

  const styles = {
    '.carousel-card': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: isMobile ? '300px' : '600px',
      marginTop: '80px'
    },
    '.image-container': {
      position: 'relative',
      maxWidth: '100%'
    },
    '.overlay': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      // background: "rgba(0, 0, 0, 0.5)",
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },
    '.text-content': {
      color: '#fff',
      textAlign: 'center',
      padding: '20px'
    },
    '.heading': {
      fontSize: isMobile ? '20px' : '24px',
      fontWeight: 'bold',
      marginBottom: '10px'
    },
    '.content': {
      fontSize: '16px'
    }
  };

  return (
    <Carousel showArrows={false} selectedItem={currentIndex}>
      {carousel.map((data, index) => (
        <div key={index} style={styles['.carousel-card']}>
          <div style={styles['.image-container']}>
            <img src={data.image} alt={`Image ${index + 1}`} />
            <div style={styles['.overlay']}>
              <div style={styles['.text-content']}>
                <div style={styles['.heading']}>
                  {isMobile ? data.text.heading : data.text.heading}
                </div>
                {!isMobile && <div style={styles['.content']}>{data.text.content}</div>}
              </div>
            </div>
          </div>
        </div>
      ))}
    </Carousel>
  );
};

export default CarouselSection;
